import { ArrowLeft } from "lucide-react";
import { CONTACT } from "../lib/menuData";

const H = ({ children }) => <h2 className="font-serif text-2xl text-gold mt-9 mb-3">{children}</h2>;
const P = ({ children }) => <p className="text-cream/75 leading-relaxed mb-3">{children}</p>;
const Note = ({ children }) => (
  <p className="text-gold-light/90 text-sm bg-gold/10 border border-gold/25 rounded-sm px-4 py-3 mb-4">{children}</p>
);

const Impressum = () => (
  <>
    <H>Angaben gemäß § 5 DDG (TMG)</H>
    <P>Ceylon Royal Kitchen<br />{CONTACT.address}</P>
    <Note>Bitte ergänze noch die Umsatzsteuer-Identifikationsnummer (falls vorhanden).</Note>
    <P>Inhaberin: Tanja Thangarasa</P>
    <P>Rechtsform: Einzelunternehmen</P>
    <H>Kontakt</H>
    <P>Telefon: {CONTACT.phone}<br />E-Mail: info@ceylonroyal.de<br />Web: {CONTACT.website}</P>
    <H>Umsatzsteuer-ID</H>
    <P>Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG: [bitte ergänzen]</P>
    <H>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</H>
    <P>Tanja Thangarasa, Anschrift wie oben.</P>
    <H>Verbraucherstreitbeilegung</H>
    <P>Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</P>
  </>
);

const Datenschutz = () => (
  <>
    <H>1. Verantwortlicher</H>
    <P>Ceylon Royal Kitchen, {CONTACT.address}, Telefon {CONTACT.phone}, E-Mail info@ceylonroyal.de.</P>
    <H>2. Verarbeitung bei Bestellungen & Anfragen</H>
    <P>Wenn du über unsere Website eine Abholbestellung aufgibst oder das Kontakt-/Catering-Formular nutzt, verarbeiten wir die von dir angegebenen Daten (z. B. Name, Telefonnummer, ggf. E-Mail, Bestell- bzw. Anfrageinhalt), um deine Bestellung bzw. Anfrage zu bearbeiten. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b und f DSGVO.</P>
    <P>Eine Bezahlung erfolgt vor Ort bei Abholung; wir erheben online keine Zahlungsdaten.</P>
    <H>3. Speicherdauer</H>
    <P>Wir speichern die Daten nur so lange, wie es zur Bearbeitung erforderlich ist bzw. gesetzliche Aufbewahrungsfristen bestehen.</P>
    <H>4. E-Mail-Versand</H>
    <P>Für den Versand von Bestell- und Anfragebestätigungen setzen wir einen E-Mail-Dienstleister als Auftragsverarbeiter ein. Dabei werden die für den Versand nötigen Daten verarbeitet.</P>
    <H>5. Google Maps</H>
    <P>Zur Anzeige unseres Standortes binden wir Google Maps ein. Beim Laden der Karte kann deine IP-Adresse an Google übertragen werden. Anbieter: Google Ireland Ltd. Weitere Infos: policies.google.com/privacy. Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.</P>
    <H>6. Server-Logfiles</H>
    <P>Beim Aufruf der Website werden technisch notwendige Daten (z. B. IP-Adresse, Zeitpunkt, abgerufene Seite) temporär verarbeitet, um den Betrieb und die Sicherheit zu gewährleisten.</P>
    <H>7. Deine Rechte</H>
    <P>Du hast das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit und Widerspruch sowie ein Beschwerderecht bei einer Aufsichtsbehörde. Wende dich dazu an info@ceylonroyal.de.</P>
    <Note>Dies ist eine allgemeine Vorlage. Bitte lasse sie vor dem Live-Gang rechtlich prüfen und ergänze fehlende Angaben.</Note>
  </>
);

const AGB = () => (
  <>
    <H>1. Geltungsbereich</H>
    <P>Diese Bedingungen gelten für Bestellungen zur Abholung, die über die Website von Ceylon Royal Kitchen aufgegeben werden.</P>
    <H>2. Bestellung & Vertrag</H>
    <P>Mit dem Absenden der Bestellung gibst du ein Angebot ab. Der Vertrag kommt mit unserer Bestätigung (telefonisch oder per E-Mail) bzw. mit der Zubereitung zustande.</P>
    <H>3. Abholung & Bezahlung</H>
    <P>Die Bestellung wird zur Abholung in der {CONTACT.address} vorbereitet. Die Bezahlung erfolgt vor Ort bei Abholung – bar oder mit Karte. Eine Online-Zahlung wird derzeit nicht angeboten.</P>
    <H>4. Preise</H>
    <P>Alle Preise verstehen sich in Euro inklusive der gesetzlichen Mehrwertsteuer.</P>
    <H>5. Allergene & Zusatzstoffe</H>
    <P>Angaben zu Allergenen und Zusatzstoffen findest du in der Speisekarte bzw. erhältst du auf Anfrage.</P>
    <H>6. Widerruf</H>
    <P>Bei der Lieferung/Zubereitung von Speisen, die schnell verderben können, besteht kein Widerrufsrecht (§ 312g Abs. 2 Nr. 2 BGB).</P>
    <H>7. Anbieter</H>
    <P>Ceylon Royal Kitchen, {CONTACT.address}. Kontakt: {CONTACT.phone}, info@ceylonroyal.de.</P>
    <Note>Dies ist eine allgemeine Vorlage. Bitte vor dem Live-Gang rechtlich prüfen lassen.</Note>
  </>
);

const CONTENT = {
  impressum: { title: "Impressum", body: <Impressum /> },
  datenschutz: { title: "Datenschutzerklärung", body: <Datenschutz /> },
  agb: { title: "AGB", body: <AGB /> },
};

export const LegalPage = ({ page }) => {
  const c = CONTENT[page] || CONTENT.impressum;
  return (
    <div className="min-h-screen bg-teal-dark grain">
      <div className="relative z-10 max-w-3xl mx-auto px-5 md:px-10 py-16">
        <a href="/" data-testid="legal-back" className="inline-flex items-center gap-2 text-gold hover:text-gold-light mb-10">
          <ArrowLeft size={18} /> Zurück zur Startseite
        </a>
        <div className="flex items-center gap-3 mb-8">
          <img src="/logo.png" alt="Ceylon Royal Kitchen" className="h-12 w-auto rounded-md" />
          <span className="font-serif text-xl text-cream">Ceylon Royal <span className="text-gold">Kitchen</span></span>
        </div>
        <h1 className="font-serif text-4xl md:text-5xl text-cream mb-4" data-testid="legal-title">{c.title}</h1>
        <div className="border-t border-gold/20 pt-6">{c.body}</div>
      </div>
    </div>
  );
};
